import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gettext } from '../utils/text';

const ProjectFundsElement = (props) => (
    <div className="project-funds__element">
        <input
            type="text"
            className="project-funds__description form-control mt-1"
            placeholder={gettext('Description')}
            value={props.description}
            onChange={(e) => props.onChange(e, props.order, 'description')}
            readOnly={props.lockDescription}
        />
        <div className={classNames('mt-1', { 'input-group': props.canDelete })}>
            <input
                type="number"
                className="project-funds__amount form-control"
                placeholder={gettext('Description')}
                value={props.amount}
                onChange={(e) => props.onChange(e, props.order, 'amount')}
                min={0}
                step={10}
                max={props.maxAmount}
            />
            {props.canDelete && (
                <div className="input-group-append">
                    <button type="button" className="btn btn-danger" onClick={() => props.removeElement(props.order)}>
                        <i className="icon icon--cross" />
                    </button>
                </div>
            )}
        </div>
    </div>
);

ProjectFundsElement.propTypes = {
    description: PropTypes.string.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    order: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    removeElement: PropTypes.func.isRequired,
    lockDescription: PropTypes.bool, // Lock description
    canDelete: PropTypes.bool,
    maxAmount: PropTypes.number,
};

ProjectFundsElement.defaultProps = {
    lockDescription: false,
    canDelete: true,
    maxAmount: undefined,
};

export default ProjectFundsElement;



// WEBPACK FOOTER //
// ./src/components/ProjectFundsElement.js